import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { AuthManagerInstance } from 'utils/auth/AuthManager'
import { getPortalUrlWithParams } from 'utils/helpers/url'
import * as meSelectors from 'store/statics/me/meSelectors'
import * as meActions from 'store/statics/me/meActions'
import { WelcomeModalView } from 'containers/common/welcomeModal/WelcomeModalView'

interface Props {
  setIsConfirmationLogoutModalOpen: (isOpen: boolean) => void
  setIsWelcomeModalOpen: (isOpen: boolean) => void
  handleShowCreateAccountForm: () => void
  isWelcomeModalOpen: boolean
}

export const useWelcomeModal = ({
  setIsConfirmationLogoutModalOpen,
  setIsWelcomeModalOpen,
  handleShowCreateAccountForm,
  isWelcomeModalOpen,
}: Props) => {
  const [isPending, setIsPending] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const dispatch = useDispatch()
  const user = useSelector(meSelectors.getStatic)
  const isApplicant = !!user?.applicant

  const dispatchFetchMe = () => dispatch(meActions.fetchData())

  const portalUrl = getPortalUrlWithParams()

  const handleStartApp = () => {
    if (AuthManagerInstance.authenticated) {
      setIsConfirmationLogoutModalOpen(true)
    } else {
      handleShowCreateAccountForm()
    }

    setIsWelcomeModalOpen(false)
  }

  useEffect(() => {
    if (AuthManagerInstance.authenticated) {
      setIsAuthenticated(true)
      dispatchFetchMe().finally(() => setIsPending(false))
    } else {
      setIsPending(false)
    }
    // eslint-disable-next-line
  }, [])

  const WelcomeModal = (
    <WelcomeModalView
      isWelcomeModalOpen={isWelcomeModalOpen}
      isApplicant={isApplicant}
      isPending={isPending}
      isAuthenticated={isAuthenticated}
      portalUrl={portalUrl}
      handleStartApp={handleStartApp}
      user={user}
    />
  )

  return {
    WelcomeModal,
  }
}
